import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history, fetchWrapper } from "../_helpers";
import { getStoredValue, removeStoredValue, setStoredValue } from "../_helpers/storagehelper";

// create slice

const name = "auth";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
  const publicUserId = getStoredValue("userID");
  return {
    // initialize state from local storage to enable user to stay logged in
    user: getStoredValue("user"),
    error: null,
    emailSaveResponse: [],
    PublicUserActivationEmailResponse: [],
    registerEmailActivateResponse: [],
    ActiveMailResponse: [],
    LoadApplicationMaintenceResponse: [],
    isAuthenticated: getStoredValue(`isAuthenticated_${publicUserId?.toString()}`) || false,
    token: null,
    InspectElementBlockResponse: 0,
    isSignalRData : '',
    connectionData :'',
    IP:""
  };
}

function createReducers() {
  return {
    logout,
    clearEmailResponse,
    clearEmailSaveResponse,
    clearRegisterEmailActivateResponse,
    setToken,
    updateSignalRData,
    updateconnectionData,
  };

   function updateSignalRData(state, action) {
    state.isSignalRData = action.payload && action.payload;
  }

  function updateconnectionData(state, action) {
    state.connectionData = action.payload && action.payload;
  }


  function clearEmailResponse(state) {
    state.PublicUserActivationEmailResponse = [];
    state.ActiveMailResponse = [];
    state.emailSaveResponse = [];
    state.registerEmailActivateResponse = [];
    state.user = null;
  }
  function clearEmailSaveResponse(state) {
    state.emailSaveResponse = [];
  }

  function setToken(state, action) {
    state.token = action.payload; // Assign token to state
    state.isAuthenticated = true;
    const publicUserId = getStoredValue("userID");
    sessionStorage.setItem(`isAuthenticated_${publicUserId?.toString()}`, true);
  }

  function clearRegisterEmailActivateResponse(state) {
    state.registerEmailActivateResponse = [];
  }
  function logout(state) {
    state.user = null;
    removeStoredValue("user");
    const publicUserId = getStoredValue("userID");
    localStorage?.setItem(`isAuthenticated_${publicUserId?.toString()}`, false);
    state.isAuthenticated = false;
    sessionStorage.setItem(`isAuthenticated_${publicUserId?.toString()}`, false);
    var oldsignalRId = getStoredValue(`signalRId_${getStoredValue("userID")}`);
		if (oldsignalRId && state.connectionData?._connectionState == "Connected") {
			state.connectionData.invoke("RemoveUser", oldsignalRId.toString())
		}    removeStoredValue(`signalRId_${getStoredValue("userID")}`);
    state.token = null;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/LoginUser`;
  const commonUrl =  `${process.env.REACT_APP_API_URL}`;

  return {
    login: login(),
    resendActiveMail: resendActiveMail(),
    PublicUserActivationEmailDetails: PublicUserActivationEmailDetails(),
    SendUsernameForget: SendUsernameForget(),
    PublicUserLoginActivationStatus: PublicUserLoginActivationStatus(),
    UsPublicSubscribeUnsubscribeMail: UsPublicSubscribeUnsubscribeMail(),
    PublicUserUnsubscribeMail: PublicUserUnsubscribeMail(),
    InviteLink: InviteLink(),
    LoadApplicationMaintence: LoadApplicationMaintence(),
    InspectElementBlock: InspectElementBlock(),
    GetIPAddress : GetIPAddress()
  };

  function GetIPAddress() {
    return createAsyncThunk(
      `${name}/GetIPAddress`,
      async () =>
        await fetchWrapper.get(`${commonUrl}/Common/GetIPAddress`)
    );
  }

  function login() {
    return createAsyncThunk(
      `${name}/login`,
      async (loginForm) =>
        await fetchWrapper.get(
          `${baseUrl}/GetPublicLoginValidate?UserName=${loginForm?.UserName}&UserPassword=${loginForm?.UserPassword}&BrowserType=${loginForm?.BrowserType}&IPAddress=${loginForm?.IPAddress}`
        )
    );
  }
  function resendActiveMail() {
    return createAsyncThunk(
      `${name}/resendActiveMail `,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LogPublicUserResendActivationEmail?publicUserID=${data.publicUserID}&userActivateURL=${data.userActivateURL}&userType=${data.userType}`
        )
    );
  }
  function PublicUserActivationEmailDetails() {
    return createAsyncThunk(
      `${name}/PublicUserActivationEmailDetails `,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/ResendActivationLink?publicUserID=${data.publicUserID}&publicUserEmail=${data.publicUserEmail}&userType=${data.userType}`
        )
    );
  }
  function SendUsernameForget() {
    return createAsyncThunk(
      `${name}/SendUsernameForget `,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/GetValidateUsernameEmailExist?email=${data.email}&userType=${data.userType}&forgotType=${data.forgotType}`
        )
    );
  }
  // Public User first time register then click activation link means show the status in login page
  function PublicUserLoginActivationStatus() {
    return createAsyncThunk(
      `${name}/PublicUserLoginActivationStatus `,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/ActivationLink?url=${data.url}&userType=${
            data.userType
          }&publicUserEmail=${"''"}&userID=${data.userID}`
        )
    );
  }
  function UsPublicSubscribeUnsubscribeMail() {
    return createAsyncThunk(
      `${name}/UsPublicSubscribeUnsubscribeMail `,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/UsPublicSubscribeUnsubscribeMail?email=${data.email}`
        )
    );
  }

  function PublicUserUnsubscribeMail() {
    return createAsyncThunk(
      `${name}/PublicUserUnsubscribeMail `,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/PublicUserUnsubscribeMail?UserID=${data.userID}`
        )
    );
  }
  function InviteLink() {
    return createAsyncThunk(
      `${name}/GetLoadInmateInviteInfo `,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/GetLoadInmateInviteInfo?InmateID=${data.InmateID}&publicUserID=${data.PublicUserId}&InviteGUID=${data.InviteGUID}`
        )
    );
  }

  function LoadApplicationMaintence() {
    return createAsyncThunk(
      `${name}/LoadApplicationMaintence `,
      async (data) =>
        await fetchWrapper.get(`${baseUrl}/LoadApplicationMaintence`)
    );
  }
  function InspectElementBlock() {
    return createAsyncThunk(
      `${name}/InspectElementBlock `,
      async (data) => await fetchWrapper.get(`${baseUrl}/InspectElementBlock`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    // Handle login actions
    .addCase(extraActions.login.pending, (state) => {
      state.error = null;
      state.user = "";
    })
    .addCase(extraActions.login.fulfilled, (state, action) => {
      const user = action.payload;
      setStoredValue("user", user);
      setStoredValue("userID", user?.PublicUserID);
      setStoredValue("PUPasswordLogID", user?.PUPasswordLogID);
      const publicUserId = getStoredValue("userID");
      localStorage.setItem(`isAuthenticated_${publicUserId?.toString()}`, true);
      localStorage.setItem("issmanuallogout", false);
      state.user = user;
      state.token = user?.LoginToken;
      state.registerEmailActivateResponse = [];
      state.isAuthenticated = true;
      sessionStorage.setItem(`isAuthenticated_${publicUserId?.toString()}`, true);
      setStoredValue("isSALoginAsPU", user?.IsSALoginAsPU);
      setStoredValue("userName", user?.UserName);
      // const { from } = history?.location?.state || { from: { pathname: "/" } };    // Reason Comment line it refresh the logic page
      // const { from } = history?.location?.state || { from: { pathname: "/" } };    // Reason Comment line it refresh the logic page
      // history.navigate(from);   // Reason Comment line it refresh the logic page
    })
    .addCase(extraActions.login.rejected, (state, action) => {
      state.error = action.error.message;
    })

    // Handle resendActiveMail actions
    .addCase(extraActions.resendActiveMail.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.resendActiveMail.fulfilled, (state, action) => {
      //  const user = action.payload;
      state.ActiveMailResponse = action.payload;
    })
    .addCase(extraActions.resendActiveMail.rejected, (state, action) => {
      state.error = action.error.message;
    })
    // Handle SendUsernameForget actions
    .addCase(extraActions.SendUsernameForget.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.SendUsernameForget.fulfilled, (state, action) => {
      state.emailSaveResponse = action.payload;
    })
    .addCase(extraActions.SendUsernameForget.rejected, (state, action) => {
      state.error = action.error.message;
    })

    // Handle PublicUserLoginActivationStatus actions
    .addCase(extraActions.PublicUserLoginActivationStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.PublicUserLoginActivationStatus.fulfilled,
      (state, action) => {
        state.registerEmailActivateResponse = action.payload;
      }
    )
    .addCase(
      extraActions.PublicUserLoginActivationStatus.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    // Handle UsPublicSubscribeUnsubscribeMail actions
    .addCase(extraActions.UsPublicSubscribeUnsubscribeMail.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.UsPublicSubscribeUnsubscribeMail.fulfilled,
      (state, action) => {}
    )
    .addCase(
      extraActions.UsPublicSubscribeUnsubscribeMail.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    // Handle PublicUserUnsubscribeMail actions
    .addCase(extraActions.PublicUserUnsubscribeMail.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.PublicUserUnsubscribeMail.fulfilled,
      (state, action) => {}
    )
    .addCase(
      extraActions.PublicUserUnsubscribeMail.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    // Handle InviteLink actions
    .addCase(extraActions.InviteLink.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.InviteLink.fulfilled, (state, action) => {})
    .addCase(extraActions.InviteLink.rejected, (state, action) => {
      state.error = action.error.message;
    })

    // Handle PublicUserActivationEmailDetails actions
    .addCase(extraActions.PublicUserActivationEmailDetails.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.PublicUserActivationEmailDetails.fulfilled,
      (state, action) => {
        // const user = action.payload;
        state.PublicUserActivationEmailResponse = action.payload;
        const user = action.payload;
        if (user && user.OutputStatus === 1) {
          setStoredValue("user", user);
          state.userSecurityDetail = [];
          state.user = user;
          // get return url from location state or default to home page
          let path = "";
          const { from } = history.location.state || {
            from: { pathname: "/" + path },
          };
          history.navigate(from);
          // store user details and jwt token in local storage to keep user logged in between page refreshes
        }
      }
    )
    .addCase(
      extraActions.PublicUserActivationEmailDetails.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    // Handle LoadApplicationMaintence actions
    .addCase(extraActions.LoadApplicationMaintence.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.LoadApplicationMaintence.fulfilled,
      (state, action) => {
        state.LoadApplicationMaintenceResponse = action.payload;
      }
    )
    .addCase(
      extraActions.LoadApplicationMaintence.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    // Handle InspectElementBlock actions
    .addCase(extraActions.InspectElementBlock.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.InspectElementBlock.fulfilled, (state, action) => {
      state.InspectElementBlockResponse = action.payload;
    })
    .addCase(extraActions.InspectElementBlock.rejected, (state, action) => {
      state.error = action.error.message;
    })
    .addCase(extraActions.GetIPAddress.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.GetIPAddress.fulfilled,
      (state, action) => {
        state.IP = action.payload;
        if (action.payload?.IpAddress) {
          setStoredValue("cachedIP", action.payload?.IpAddress);
        }
      }
    )
    .addCase(
      extraActions.GetIPAddress.rejected,
      (state, action) => {
        state.error = action.error;
      }
    );
}
